import { PermissionGuard } from "@/components/PermissionGuard";
import { OwnerFinancialTab } from "@/components/owners/OwnerFinancialTab";

interface MobileOwnerFinancialTabProps {
  ownerId: string;
  petIds: string[];
}

export function MobileOwnerFinancialTab({ ownerId, petIds }: MobileOwnerFinancialTabProps) {
  return (
    <PermissionGuard resource="patient_financial" action="view" showAlert={false}>
      <OwnerFinancialTab ownerId={ownerId} petIds={petIds} />
    </PermissionGuard>
  );
}
